import { DynamicForm } from '../../DynamicForm';
import { SettingItemList } from '../../SettingItemList';
import { useCreateOperator } from '../../../../../contexts/CreateOperatorContext';
import { FIPSCode } from './FIPSCode';
import React from 'react';

export const FIPS = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  const handleRemove = (codeIndex: number) => {
    updateOperator(
      'fipsCodes',
      (operator.fipsCodes ?? []).filter((value, index) => index !== codeIndex)
    );
  };

  const handleSave = (item: CreateFipsCode, codeIndex: number) => {
    updateOperator(
      'fipsCodes',
      (operator.fipsCodes ?? []).map((value, index) => {
        if (index === codeIndex) return item;
        return value;
      })
    );
  };

  return (
    <div className={classes.container}>
      <DynamicForm<CreateFipsCode>
        defaultForm={{ active: true, code: '', county: '' }}
        inputs={[
          {
            order: 0,
            rowInputs: [
              {
                props: {
                  name: 'county',
                  label: 'County Name',
                  value: (values) => values.county,
                  required: false, // TODO: Disabling for now, Original setting: true,
                },
              },
              {
                props: {
                  name: 'code',
                  label: 'FIPS Code',
                  value: (values) => values.code,
                  required: false, // TODO: Disabling for now, Original setting: true,
                },
              },
            ],
          },
        ]}
        submitButton={{ text: 'Add FIPS Code' }}
        onSubmit={(values) =>
          updateOperator('fipsCodes', [values, ...(operator.fipsCodes ?? [])])
        }
        validation={(values) => values.county !== '' && values.code !== ''}
      />
      <SettingItemList<CreateFipsCode>
        items={operator.fipsCodes ?? []}
        name="FIPS Codes"
        renderRow={(item, index) => (
          <FIPSCode
            fipsCode={item}
            index={index}
            onRemove={handleRemove}
            onSave={handleSave}
          />
        )}
      />
    </div>
  );
};

const useStyles = () => ({
  container: 'flex flex-col gap-4 items-center',
});
